<template>
	<div id="art-page">
		<content-view :color="color">
			<template slot="intro">
				<div class="center">
					<div class="text">
						<h1 v-collide="'fadeInLeft'">На пике формы</h1>
						<p v-collide="'fadeInUp'">
							Хочешь оказаться на пике своих творческих увлечений? Нарисовать первую
							в жизни картину, научиться играть на музыкальном инструменте или просто
							освоить какой-то новый творческий навык? В этом тебе поможет Павел Артемьев.
							Прекрасный наставник, который знает, как творчество может помочь в самых разных
							вопросах – от развития карьеры через правильное хобби до улучшения общего
							уровня комфорта в жизни.
						</p>

						<div class="wrap">
							<img :src="getImg('intro-text-image.png')" v-collide="'fadeInUp'">
							<p v-collide="'fadeInRight'">
								Специально для тебя наставник подготовил персональные
								программы по творческому росту, рассчитанные
								на 4 месяца. Чтобы получить их — нужно просто оставить
								свой мейл. Готов? Тогда вперед!
							</p>
						</div>
					</div>
				</div>
			</template>
			<template slot="programs">
				<div id="program-1" :class="{'visible': visible.first}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 1</h2>
									<a v-if="!visible.first" class="button button-show" @click="visible.first = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<h3 v-if="visible.first" v-collide="'fadeInUp'">Искусство</h3>
								<p v-if="visible.first" v-collide="'fadeInLeft'">Привет! Наше первое занятие по развитию творческой деятельности будет состоять из трех важных советов,
									которым необходимо следовать каждый день.</p>
							</div>
						</div>
						<div v-if="visible.first" class="program-blocks">
							<div class="program-block program-block-1" >

								<div class="text" v-collide="'fadeInLeft'">
									<p>
										Решите, чего вы хотите добиться – успеха и признания или вам важен сам по себе процесс. Перед тем как
										заниматься своим развитием в творческом плане, стоит четко ответить самому себе на следующие вопросы:
									</p>
									<p>
										- Что для вас успех в творчестве?
									</p>
									<p>
										- Какими критериями вы его измеряете?
									</p>
									<p>
										Если ответы на эти вопросы для вас не очень важны, то, скорее всего вы уже определились с выбором
										и занимаетесь любимым делом в наиболее комфортной для вас форме.
									</p>
								</div>
								<img :src="getImg('program-1-1.png')" v-collide="'fadeIn'">
							</div>

							<div class="program-block program-block-2" >
								<div v-collide="'fadeInLeft'" class="text">
									<p>
											Следуйте процессу творчества. Процесс (написание песни, сочинение стихотворения, да даже лепка из глины) - это самый главный и определяющий фактор на пути к успеху. Полюбите
											процесс, полюбите и результат. Да, часто художники и музыканты любят порассуждать
											о поиске вдохновения и ожидании прихода Музы. Но, если вы любите своё дело, то Муза
											вам не нужна. Поверьте.
									</p>
								</div>
								<img :src="getImg('program-1-2.png')" v-collide="'fadeInRight'">
							</div>

							<div class="program-block program-block-3" v-collide="'fadeInLeft'">
								<div class="text">
									<p>
										Не спешите. Творчество – это неторопливый процесс. Каждый день, хотя бы короткий отрезок времени, посвящайте творческой деятельности. Сделайте это привычкой. Если вы музыкант,
										то каждый день хоть немного, но проводите за своим инструментом. Находитесь в этом процессе осознанно, и вдохновение само будет проситься посидеть рядом с вами.
									</p>
								</div>
								<a v-collide="'fadeInLeft'" @click="visible.first = false" v-if="visible.first" class="button button-hide">
									<span>Скрыть</span>
								</a>
							</div>

						</div>

					</div>
					<Sides/>
				</div>

				<div id="program-2" :class="{'visible': visible.second}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 2</h2>
									<a v-collide="'fadeInUp'" v-if="!visible.second" class="button button-show" @click="visible.second = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<h3 v-if="visible.second" v-collide="'fadeInUp'">Творчество</h3>
							</div>

						</div>
						<div v-if="visible.second" class="program-blocks">
							<div class="program-block program-block-1">
								<div class="text"  v-collide="'fadeInUp'">
									<p>Заведите дневник. Это может быть простой блокнот, который вы будете носить с собой.
										Подойдет даже записная книжка в телефоне. Вы ведь не знаете, когда вас посетит идея,
										не записав которую, вы будете очень жалеть.
									</p>
								</div>
								<img v-if="visible.second" :src="getImg('program-2-1.png')" v-collide="'fadeInLeft'">
							</div>
							<div v-collide="'fadeInRight'" class="program-block program-block-2">
								<div class="text">
									<p>
										Стихи иногда приходят не целиком, а собираются как пазлы. По кусочкам. Именно поэтому
										так важно иметь дневник под рукой. Записывайте туда все, что приходит на ум, и даже то,
										что кажется неважным. Одно слово в итоге может послужить триггером для написания целой истории. Яркая фраза может стать началом хитовой песни, а забавный образ — ключом
										к замку, на который заперто ваше вдохновение.
									</p>
								</div>
								<img v-collide="'fadeInLeft'" :src="getImg('program-2-2.png')">
							</div>
							<div v-collide="'fadeInUp'" class="program-block program-block-3">
								<div class="text">
									<p>
										И никогда не критикуйте свои идеи — просто запоминайте и записывайте. Уверяем, первые
										результаты не заставят долго ждать.
									</p>
								</div>
							</div>
						</div>
						<a v-collide="'fadeInRight'"
						   @click="visible.second = false"
						   v-if="visible.second"
						   class="button button-hide">
							<span>Узнать подробнее</span>
						</a>
					</div>


					<Sides/>
				</div>
			</template>


			<template slot="programs_bottom">
				<div id="program-3" :class="{'visible': visible.third}">
					<div class="center">
						<div class="program-header">
							<div  class="header">
								<h2 v-collide="'fadeInLeft'">Программа 3</h2>
								<a v-collide="'fadeInLeft'"  v-if="!visible.third" class="button button-show" @click="visible.third = true">
									<span>Узнать подробнее</span>
								</a>
							</div>
							<div class="text">
								<h3 v-collide="'fadeInLeft'"  v-if="visible.third" >Искусство</h3>
							</div>
						</div>
						<div v-if="visible.third" class="program-blocks">
							<div class="program-block program-block-1">
								<div v-collide="'fadeInLeft'"  class="text">
									<h6>Работайте с максимально мотивированными и профессиональными людьми. </h6>
									<p>
										Как известно, в одиночку идти к успеху значительно сложнее. Отдельным талантом считается умение
										аккумулировать вокруг себя правильную рабочую энергию, создавать команды заинтересованных, любящих
										свое дело людей.
									</p>
								</div>
								<img v-if="visible.third" :src="getImg('program-3-1.png')" v-collide="'fadeIn'">
							</div>

							<div class="program-block program-block-2"  >
								<div v-collide="'fadeInLeft'" class="text">
									<h6>Помните: </h6>
									<p>
											даже если вы работаете большой командой, ответственность за результат несете только вы как лидер
											коллектива. Поэтому, собирая вокруг себя единомышленников, обращайте внимание не только на такие
											факторы, как внутренняя организованность и общий кругозор кандидата, но и на то, что подсказывает ваш
											собственный инстинкт. Ведь если вам по каким-то бытовым причинам сложно найти общий язык с человеком, то и в творчестве разногласия между вами могут оказаться непреодолимыми преградами. Если мы говорим
											о группе, важно помнить: несмотря на то что вы можете делать общее дело, в конечном итоге довести
											его до конца нужно только вам. Помните о компромиссах. Не отвлекайтесь на конфликты и пустяки. Если
											человек вам не подходит, идите дальше. У вас есть цель. Никогда не забывайте об этом.
										</p>
									<a @click="visible.third = false" v-if="visible.third" class="button button-hide">
										<span>Скрыть</span>
									</a>
								</div>
								<img v-if="visible.third" :src="getImg('program-3-2.png')" v-collide="'fadeIn'">
							</div>
						</div>

					</div>
				</div>
				<Subscribe />
				<Sides/>
			</template>
			<template slot="product">
				Новый KIA Sportage станет твоим проводником в мир, полный открытий
				и приключений, ведь это автомобиль - на пике формы! Слова не нужны —
				притягивающий взгляды KIA Sportage говорит сам за себя. В пробках,
				на трассе или на парковке у дома – это автомобиль везде выглядит
				превосходно, сочетая спортивный дух и яркую внешность. Капот
				с выступающими гранями и решетка радиатора в фирменном стиле KIA
				наделяют Sportage уникальной спортивной внешностью, а задние
				фонари выделяют дополнительные акценты, завершая образ автомобиля.
			</template>
		</content-view>
	</div>
</template>


<script>
    import ContentView from '@/components/ContentV2'
    import Sides from '@/components/Sides'
    import Subscribe from '@/components/Subscribe'
    import { colors } from '@/data/pages'
    import LINKS from '@/data/links';

    export default {
        name: 'Art',
        components: {
            ContentView,
            Sides,
            Subscribe
        },
        data() {
            return {
                visible: {
                    first: false,
                    second: false,
                    third: false
                },
                color: colors[this.$route.name],
            }
        },
        computed: {
            learnmoreLink() {
                return LINKS[this.route]
            },
        },
        methods: {

            getImg(name) {
                return require(`@/assets/images/${this.$route.name}/${name}`)
            },
        }
    }
</script>

<style lang="less">
	@import '../styles/variables';

	#art-page {
		.program-block {
			@media (max-width: 959px) {
				img {
					display: block;
					width: 100%;
					max-width: 100%;
				}
			}
			.text {
				position: relative;
				&:before {
					content: "";
					font-family: @font-bold;
					display: block;
					font-size: 100px;
					color: #000;
					position: absolute;
					z-index: 0;
					top: -80px;
					left: 96px;
				}
				p {
					position: relative;
				}
				h6 {
					position: relative;
				}
			}
		}
		.program-block-1 {
			.text:before {
				content: "1";
			}
		}
		.program-block-2 {
			.text:before {
				content: "2";
			}
		}
		.program-block-3 {
			.text:before {
				content: "3";
			}
		}

		#program-1 {
			position: relative;
			z-index: 1;
			.program-header {
				&:before {
					content: "";
					display: block;
					position: absolute;
					width: 70%;
					height: 50%;
					background: url('../assets/images/art/dots-1.png') no-repeat center center;
					background-size: contain;
					top: 0;
					left: -12.5%;
				}
				h2 {
					display: block;
				}
				img {
					position: relative;
					width: calc(~'100% + 40px');
					z-index: 2;
					display: block;
					margin-top: 30px;
					@media (max-width: 959px) {
						left: -20px;
					}

					@media (min-width: 960px) {
						right: 0;
						width: 100%;
						max-width: 60%;
						margin-left: auto;

					}
				}

				.text {
					margin-top: 70px;
					margin-bottom: 30px;
					z-index: 3;
					position: relative;
					@media (min-width: 960px) {
						left: 10%;
						max-width: 70%;
						margin-bottom: 0;
					}
					&:before {
						content: "";
						display: block;
						position: absolute;
						right: -120px;
						top: -10px;
						width: 70px;
						height: 110px;
						background: url('../assets/images/art/arrows-double-1.png') no-repeat center center;
						background-size: contain;
					}
					&:after {
						content: "";
						display: block;
						position: absolute;
						left: -12.5%;
						top: 280px;
						width: 60px;
						height: 100px;
						background: url('../assets/images/art/arrows-double-2.png') no-repeat center center;
						background-size: contain;
					}
				}

			}

			.sides {
				bottom: 0;
			}

			@media (min-width: 960px) {
				.program-block-1 {
					margin-top: 60px;
					margin-left: 10%;
					.text {
						padding-right: 40px;
					}
					img {
						display: block;
						margin-left: auto;
						max-width: 60%;
					}
				}

				.program-block-2 {
					margin-top: 60px;
					img {
						margin-left: auto;
						display: block;
						max-width: 60%;
					}
					.text {
						margin-left: 0;
						max-width: 70%;
					}
				}
				.program-block-3 {
					margin-left: 10%;
					max-width: 60%;
					.text {
						margin-bottom: 30px;
					}
				}
				.button {
					margin-left: 24px;
				}
			}
			.program-block-2 {

			}
			.program-block-3 {
				margin-top: 90px;
				margin-bottom: 90px;
			}
			.button {
				margin-bottom: 60px;
				&:after {
					display: none;
				}
			}
			.header {
				width: auto;
				display: inline-block;
				text-align: center;
				position: relative;

				&:after {
					content: "";
					display: block;
					width: 230px;
					height: 65px;
					background: #260d06;
					position: absolute;
					bottom: -10px;
					right: -120px;
				}
			}
			.button-show {
				left: 0;
				margin: 0 auto;
				display: inline-block;
			}
		}
		#program-2 {
			position: relative;
			z-index: 0;
			margin-bottom: 60px;
			@media (min-width: 960px) {
				margin-bottom: 0;
			}

			@media (min-width: 960px) {
				margin-top: -75px;
			}
			&.visible {
				margin: 0;
			}
			.program-header {
				position: relative;
				img {
					position: relative;
					width: calc(~'100% + 40px');
					z-index: 2;
					display: block;
					margin-top: 30px;
					@media (max-width: 959px) {
						left: -20px;
					}

					@media (min-width: 960px) {
						left: 20%;
						width: 100%;
						max-width: 80%;

					}
				}

				.text {
					margin-bottom: 30px;
					z-index: 3;
					@media (min-width: 960px) {
						margin-left: 10%;
					}
					p {
						@media (min-width: 960px) {
							max-width: 50%;
							margin-bottom: 16px;
						}
					}
				}

				h2 {
					display: block;
				}

				p {
					position: relative;
					font-family: @font-light;
					font-size: 16px;
					z-index: 1;
				}
			}
			img {
				display: block;
				margin-top: 60px;
				width: 100%;
			}
			.header {
				position: relative;
				width: auto;
				display: inline-block;
				text-align: center;
				white-space: nowrap;
				@media (min-width: 960px) {
					margin-left: 40%;
				}
				&:before {
					content: "";
					display: block;
					width: 320px;
					height: 65px;
					background: #44170a;
					position: absolute;
					top: 160px;
					left: -120px;
					transform: skew(-45deg);
				}
				&:after {
					content: "";
					display: block;
					position: absolute;
					width: 40px;
					height: 40px;
					background: url('../assets/images/focus.png') no-repeat center center;
					background-size: contain;
					top: 120px;
					left: -80px;
				}
			}
			.button {
				margin-top: 30px;
				margin-bottom: 160px;
				&:after {
					transform: skew(-45deg);
				}
				@media (min-width: 960px) {
					margin-top: 60px;
					margin-bottom: 120px;
				}
			}

			.program-block-1 {
				li {
					margin-bottom: 20px;
				}
			}

			@media (min-width: 960px) {

				.program-block-1 {
					margin-top: 90px;

					.text {
						margin-left: 16%;
						max-width: 65%;
					}
					img {
						margin-top: -30px;
						max-width: 50%;
						margin-bottom: 60px;
					}
				}
				.program-block-2 {
					img {
						width: 70%;
						position: relative;
						margin-left: -10%;
						top: -72px;
					}
					.text {
						margin-left: 30%;
						max-width: 60%;
					}
				}
				.program-block-3 {
					margin-top: -80px;
					margin-bottom: 240px;
					.text {
						margin-left: 30%;
						max-width: 60%;

					}
				}
				.button {
					position: absolute;
					right: 17.5%;
					bottom: 60px;
					margin-top: 60px;
					margin-bottom: 60px;
					&:after {
						display: none;
					}
				}
				.button-show {
					position: relative;
					display: inline-block;
					bottom: 0;
					right: auto;
					margin: 0 auto;
					margin-bottom: 120px;
				}
			}
		}

		#banner {
			&:before {
				background: url('../assets/images/lines-black.png') no-repeat center center;
				background-size: contain;
			}
			&:after {
				left: 55%;
				background: url('../assets/images/lines-black.png') no-repeat center center;
				background-size: contain;
			}
		}

		#program-3 {
			.program-header {
				position: relative;
				&:before {
					content: "";
					display: block;
					width: 320px;
					height: 65px;
					background: #41170a;
					position: absolute;
					top: 160px;
					left: -30px;
					transform: skew(-45deg);
				}


				.text {
					margin-top: 65px;
					@media (min-width: 960px) {
						left: 5%;
						max-width: 60%;
					}
				}

				.header {
					margin-top: 30px;
					font-size: 16px;
					position: relative;
					font-family: @font-light;
					@media (min-width: 960px) {
						text-align: center;
						left: 5%;
						width: 95%;
						max-width: 40%;
					}
				}
			}

			.button-show {
				display: inline-block;
			}
			@media (min-width: 960px) {
				.program-block-1 {
					margin-top: 90px;
					margin-left: 5%;
					margin-bottom: 0;
					width: 100%;
					max-width: 95%;
					.text {
						max-width: 75%;
					}
					img {
						width: 80%;
						margin-left: 20%;
					}
				}

				.program-block-2 {
					margin-top: 60px;
					margin-left: 5%;
					max-width: 95%;
					margin-bottom: 240px;
					.text {
						margin-bottom: 30px;
						p {
							margin-bottom: 40px;
						}
						&:before {
							left: 12px;
						}
					}
					img {
						width: 75%;
						margin-left: 25%;
					}
				}

			}
		}
		.programs-bottom-subscribe {
			margin-top: -30px;
			.button {
				&:after {
					display: none;
				}
			}
		}
		.programs-bottom-forms {
			&:before {
				display: none;
			}
			.button {
				&:after {
					display: none;
				}
			}
			@media (min-width: 960px) {
				.inner {
					width: 45%;
					right: 10%;
				}
			}
			.inner {
				&:before {
					content: "";
					display: block;
					width: 230px;
					height: 65px;
					background: #61210f;
					position: absolute;
					top: 45px;
					left: 10px;
				}
				&:after {
					content: "";
					display: block;
					position: absolute;
					width: 40px;
					height: 40px;
					background: url('../assets/images/focus.png') no-repeat center center;
					background-size: contain;
					bottom: -80px;
					left: -120px;
				}
				h2 {
					position: relative;
					&:before {
						content: "";
						display: block;
						position: absolute;
						width: 90px;
						height: 90px;
						background: url('../assets/images/art/arrows-double-3.png') no-repeat center center;
						background-size: contain;
						bottom: -240px;
						left: -400px;
					}
				}
			}
		}
		img.collage {
			@media (min-width: 960px) {
				margin-top: -1280px;
			}
		}
		#product h2:after {
			color: #000;
		}
		#product .text {
			padding: 0 20px 60px;
		}
	}
</style>
